import {Mapper} from '@s-ui/domain'

export class FromPublishDraftResponseToUrlValueObjectMapper extends Mapper {
  constructor({config, publishDraftErrorFactory, urlPublishDraftValueObject}) {
    super()
    this._config = config
    this._PAYMENT_AD_PRODUCT_ID = this._config.get(`PAYMENT_AD_PRODUCT_ID`)
    this._IS_PAYMENT_AD_INFORMED_AT_PUBLISH_MY_AD_FORM =
      config.get(`seller`).IS_PAYMENT_AD_INFORMED_AT_PUBLISH_MY_AD_FORM
    this._adPublisherConfig = this._config.get('adPublisher')
    this._publishDraftResponseCodes = this._adPublisherConfig.publishDraftResponseCodes
    this._sendToPaymentAdUrlCodes = this._adPublisherConfig.sendToPaymentAdUrlCodes
    this._sendToUnauthorizedUrlCodes = this._adPublisherConfig.sendToUnauthorizedUrlCodes
    this._publishDraftErrorFactory = publishDraftErrorFactory
    this._urlPublishDraftValueObject = urlPublishDraftValueObject
    this._C2B_ORIGINS = this._config.get('c2b').C2B_ORIGINS
    this._INSTANT_OFFER_SELL_TO_DEALER_PATTERN = this._config.get('page').INSTANT_OFFER_SELL_TO_DEALER_PATTERN
  }

  _getUrl({
    code,
    id,
    isInstantOfferTarget,
    // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
    isGetAvailableFreeAdsEnabled
  }) {
    const hasCode = urlCode => urlCode === code
    switch (code) {
      case this._publishDraftResponseCodes.ok:
        return isInstantOfferTarget
          ? `${this._INSTANT_OFFER_SELL_TO_DEALER_PATTERN}/?adId=${id}&origin=${this._C2B_ORIGINS.PUBLISH_MY_AD}`
          : `/products/?adId=${id}&adInserted=true`
      case this._sendToPaymentAdUrlCodes.find(hasCode):
        // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
        return isGetAvailableFreeAdsEnabled && this._IS_PAYMENT_AD_INFORMED_AT_PUBLISH_MY_AD_FORM
          ? `/checkout/?adId=${id}&products=${this._PAYMENT_AD_PRODUCT_ID}`
          : `/payment-ad/?adId=${id}&c=${code}`
      case this._sendToUnauthorizedUrlCodes.find(hasCode):
        return '/poner_anuncio/sinpermisos.aspx'
      default:
        throw this._publishDraftErrorFactory(code ? `code: ${code}` : this._publishDraftResponseCodes.noCode)
    }
  }

  map({
    code,
    id,
    isInstantOfferTarget,
    // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
    isGetAvailableFreeAdsEnabled
  }) {
    const url = this._getUrl({
      code,
      id,
      isInstantOfferTarget,
      // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
      isGetAvailableFreeAdsEnabled
    })

    return this._urlPublishDraftValueObject({code, url})
  }
}
